export default "__VITE_ASSET__FO3kZ2jK__"